import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActiveTab, TabService } from "../../services/tab-service.service";
import { LanguageService } from "../../services/language.service";
import { Subscription } from "rxjs";

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.scss'
})
export class PrivacyPolicyComponent implements OnInit, OnDestroy {
  private _tabService: TabService = inject(TabService);
  private _languageService : LanguageService = inject(LanguageService);

  ACTIVE_TAB = ActiveTab;
  activeTab!: ActiveTab;

  langSubscription!: Subscription;
  currentLang!: string;

  constructor() {
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.activeTabSubscription();
    });

    this.currentLang = this._languageService.currentLang;
    this.languageSubscription();
  }

  languageSubscription(): void {
    this.langSubscription = this._languageService.onLangChange$.subscribe((event: any) => {
      this.currentLang = this._languageService.currentLang;
    });
  }

  activeTabSubscription(): void {
    // TODO need to unsubscribe logic here
    this._tabService.activeTab$.subscribe(tab => {
      this.activeTab = tab;
    });
  }

  ngOnDestroy(): void {
    if (this.langSubscription) this.langSubscription.unsubscribe();
  }
}
